<template>
  <!-- 账号密码截图 -->
  <div class="page_win reconiseInfoTip">
    <div class="head"><span>温馨提示</span></div>
    <div class="msgBox">
    <div class="msg">
      <span>致玩家：</span>
    </div>
    <div class="msg textL" >
      <span class="">根据</span
      ><span class="textColor"
        >《国家新闻出版署关于防止未成年人沉迷网络游戏的通知》</span
      ><span>:所有游戏用户均须使用有效身份信息方可进行注册登录游戏。</span>
    </div>
    <div class="msg textL">
      <span>为响应国家政策号召，营造良好的游戏环境，</span
      ><span class="textColor">请您完善实名信息再进行游戏</span><span>，由此带来的不便请您谅解!</span>
    </div>
    </div>
    <div class="botBox">
      <div class="btnL" @click="quitAccount"><span>退出账号</span></div>
      <div class="btnR" @click="goReconiseInfo"><span>继续认证</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["", ""],
  inject: ["reload"],
  data() {
    return {
      closeImg: require("../../assets/img/view10/close.png"), // 关闭
    };
  },
  creater() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    // 关闭当前窗口
    closeWin: function () {
      //   this.$store.dispatch("IsAccountAndPasFun", false);
    },
    quitAccount(){
      this.$store.commit("postPwdLoginTitle", "继续登录");
      this.$store.dispatch("IsReconiseInfoTipFun", false);
      this.$store.dispatch("IsLoginBoxFun", true);

    },
    goReconiseInfo(){
       this.$store.dispatch("IsReconiseInfoTipFun", false);
       this.$store.dispatch("IsReconiseInfoFun", true);
    }
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.head {
  @include flex_box(row, center, center);
  height: 0.5rem;
  margin-bottom: 0.1rem;
  color: #12CDB0;
  font-size: 16px;
  font-weight: bold;
}
.msgBox{
  @include flex_box(column, none, stretch);
  border: 1px solid #12CDB0;
  border-radius: .1rem;
  padding: .2rem .2rem 0 .2rem;
}
.msg {
  color: #838383;
  font-size: 12px;
  margin-bottom: 0.16rem;
  span {
    line-height: 0.3rem;
  }

}
  .textL{
    text-indent: 2em;
  }
.textColor {
  color: #12CDB0;
}
.botBox {
  @include flex_box(row, space-between, stretch);
  margin-top: .2rem;
}
.btnL,
.btnR {
  flex: 1;
  height: 0.7rem;
  border: 1px solid #696969;
  color: #696969;
  @include flex_box(row, center, center);
  border-radius: .1rem;
  span {
    letter-spacing: 2px;
  }
}
.btnR{
  border-color:#12CDB0 ;
  color:#12CDB0;
}
.btnL {
  margin-right: 0.3rem;
}
</style>


// WEBPACK FOOTER //
// src/views/view10/reconiseInfoTip.vue